/**
 * Option.js
 * Autocomplete Option component
 *
 * @module  Option
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';


export default React.createClass({

	displayName: 'Option',



	propTypes: {
		customClasses: React.PropTypes.object,
		onClick: React.PropTypes.func,
		children: React.PropTypes.string
	},

	getDefaultProps() {
		return {
			customClasses: {},
			onClick: function(event) {
				event.preventDefault();
			}
		};
	},

	componentDidMount() {
		this.refs.anchor.getDOMNode().tabIndex = -1;
	},

	getInitialState() {
		return {
			hover: false
		};
	},

  	render() {

		let classList = ClassNames( this.props.className, { selected: this.props.hover}, this.props.customClasses.listItem);
		let classAnchor = ClassNames('lui-autocomplete-option', this.props.customClasses.listAnchor);

		return (
			<li className={classList} onClick={this._onClick}>
				<a href="#" className={classAnchor} ref="anchor">
					{ this.props.children }
				</a>
	  		</li>
		);
  	},

	_onClick(event) {
		event.preventDefault();
		return this.props.onClick(event);
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/autocomplete/Option.js
 **/